export const AJAX_CALL_BEGIN = "AJAX_CALL_BEGIN";
export const AJAX_CALL_SUCCESS = "AJAX_CALL_SUCCESS";
export const AJAX_CALL_FAILURE = "AJAX_CALL_FAILURE";

export const STOP_AUTO_DISCONNECT = "STOP_AUTO_DISCONNECT";
